module.exports = __webpack_public_path__ + "static/media/siprc_dot2.407aa04f.png";